export default __webpack_public_path__ + "static/4-create-program-c8884d1e5c9c972d93785df13665ba93.jpg";